import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  submit: {
    display: "flex",
    justifyContent: "center",
  },
  submitButton: { minWidth: 180, position: "relative" },
  loading: { position: "absolute", right: theme.spacing(1) },
}));

export default function SubmitButton(props) {
  const classes = useStyles();
  const {
    submitForm,
    isSubmitting,
    text,
    handleClose,
    disabled = false,
  } = props;

  return (
    <DialogActions className={classes.submit}>
      <Button onClick={handleClose}>Cancel</Button>
      <Button
        onClick={submitForm}
        color="primary"
        variant="contained"
        autoFocus
        className={classes.submitButton}
        disabled={isSubmitting || disabled}
      >
        {text}
        {isSubmitting && (
          <CircularProgress className={classes.loading} size={28} />
        )}
      </Button>
    </DialogActions>
  );
}
